import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Vladyslav Stoliarov</span>
            <br />
            I am <span className="purple">Freelancer</span>
            <br />
            I received <span className="purple">certificate!</span> 
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Chatting
            </li>
          </ul>

          <footer className="blockquote-footer">Vladyslav Stoliarov</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
